module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rates is-pulled-left"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteRate(_vm.rate.id)
      }
    }
  }), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок",
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.updateRate(_vm.rate)
      }
    },
    model: {
      value: (_vm.rate.title),
      callback: function($$v) {
        _vm.$set(_vm.rate, "title", $$v)
      },
      expression: "rate.title"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Описание",
      "type": "textarea",
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.updateRate(_vm.rate)
      }
    },
    model: {
      value: (_vm.rate.description),
      callback: function($$v) {
        _vm.$set(_vm.rate, "description", $$v)
      },
      expression: "rate.description"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('el-select', {
    attrs: {
      "placeholder": "Выбрать символ для отображения"
    },
    on: {
      "change": _vm.symbolChanged
    },
    model: {
      value: (_vm.symbol),
      callback: function($$v) {
        _vm.symbol = $$v
      },
      expression: "symbol"
    }
  }, _vm._l((_vm.alp), function(symbol) {
    return _c('el-option', {
      key: symbol,
      attrs: {
        "label": symbol,
        "value": symbol
      }
    })
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c57c6bf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services/Rate.vue
// module id = 918
// module chunks = 0